import GenericBffClient from 'Utils/httpClients/GenericBffClient';
import { DOMAIN, LoggerFactory } from 'Services/Logger';
import { Bank } from 'Services/CustomerProfile/accounting/getBanks';
import { ProductCapabilities } from 'Models/Account/ProductCapabilities';
import { EnabledPromotion } from 'Models/Account/EnabledPromotion';
import { CashbackBalance } from 'Models/Account/CashbackBalance';

const logger = LoggerFactory.getLogger(DOMAIN.PROFILE);

export class AccountBff extends GenericBffClient {
  constructor() {
    super('ACCOUNT_BFF', '/api/v1/', { logger });
  }

  /**
   * Get bank list from Account BFF
   *
   * @returns The outcome of the request
   */
  async getBanks(): Promise<Bank[]> {
    return this.get<Bank[]>('accounting/banks');
  }

  async getProductCapabilities(): Promise<ProductCapabilities> {
    return this.get('clients/product_capabilities');
  }

  async getEnabledPromotion(merchantId: string, amount: number): Promise<EnabledPromotion> {
    return this.get(`clients/points/enabled_promotion?merchant_id=${merchantId}&amount=${amount}`);
  }

  async getCashbackBalance(): Promise<CashbackBalance> {
    return this.get('clients/points/balance_amount');
  }
}
